export default __webpack_public_path__ + "static/media/ambulance.099fef80.png";